import React from 'react';
import { Card, Rate } from 'antd';
import { ShopOutlined } from '@ant-design/icons';

const TopProviders = () => {
  const providers = [
    { name: 'Traiteur Gourmet', rating: 5, totalEvents: 45, revenue: '120K €' },
    { name: 'Déco Events', rating: 4.5, totalEvents: 38, revenue: '95K €' },
    { name: 'Sound & Light', rating: 4, totalEvents: 32, revenue: '78K €' }
  ];

  return (
    <Card
      className="h-full"
      title={
        <div className="flex items-center gap-2">
          <ShopOutlined className="text-primary-500" />
          <span className="font-heading">Top Prestataires</span>
        </div>
      }
    >
      <div className="space-y-4">
        {providers.map((provider, index) => (
          <div 
            key={index} 
            className="flex flex-col p-3 bg-neutral-50 rounded-lg hover:bg-neutral-100 transition-colors"
          >
            <div className="flex items-center justify-between mb-2">
              <span className="text-neutral-700 font-medium">{provider.name}</span>
              <Rate disabled defaultValue={provider.rating} allowHalf />
            </div>
            <div className="flex justify-between text-xs text-neutral-500">
              <span>{provider.totalEvents} événements</span>
              <span>CA: {provider.revenue}</span>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default TopProviders; 